<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <wxShare :shareTile="share.title" :shareDesc="share.desc" :shareImg="share.img" v-if="showShare"></wxShare>
    <mt-popup class="fukaPop" v-model="$root.fukaPopupVisible" popup-transition="popup-fade">
      <div class="fukaPop-window">
        <img :src="$root.fukaPhoto">
        <mt-button class="btn-received" @click="fukaPopHidden"></mt-button>
        <mt-button class="btn-close" @click="fukaPopHidden"></mt-button>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import wxShare from '@/components/wxShare/wxShare' // 微信分享
export default {
  name: 'App',
  data () {
    return {
      share: {
        title: '',
        desc: '',
        img: ''
      },
      showShare: false
    }
  },
  watch: {
    '$route' (to, from) {
      if (sessionStorage.getItem('access-token') && this.$route.name !== 'myConserve' && this.$route.name !== 'sendConfirm' && this.$route.name !== 'paySuccess' && this.$route.name !== 'addressManage' && this.$route.name !== 'sendDetail') {
        // if (localStorage.getItem('overdueOrder')) {
        //   setTimeout(() => {
        //     if (sessionStorage.getItem('webview')) {
        //       location.href = '/myConserve/10'
        //     } else {
        //       this.$router.push('/myConserve/10')
        //     }
        //     localStorage.removeItem('overdueOrder')
        //   }, 1000)
        // } else {
        //   this.isOverdueOrder()
        // }
        // if (localStorage.getItem('overdueOrder1')) {
        //   setTimeout(() => {
        //     if (sessionStorage.getItem('webview')) {
        //       location.href = '/myConserve/bill'
        //     } else {
        //       this.$router.push('/myConserve/bill')
        //     }
        //     localStorage.removeItem('overdueOrder1')
        //   }, 1000)
        // } else {
        //   this.getOverdueOrder()
        // }
        // if (localStorage.getItem('overdueOrder2')) {
        //   setTimeout(() => {
        //     if (sessionStorage.getItem('webview')) {
        //       location.href = '/myConserve/10'
        //     } else {
        //       this.$router.push('/myConserve/10')
        //     }
        //     localStorage.removeItem('overdueOrder2')
        //   }, 1000)
        // } else {
        //   this.isPopconserve()
        // }
      }
      if (to.path.indexOf('/static/towerGame') > -1) {
        window.location.href = to.path
        return
      }
      const rtName = this.$route.name
      if (rtName === 'index' || rtName === 'buyCar' || rtName === 'my' || rtName === 'discover2' || rtName === 'sami2') { // 5个主页面
        this.$router.isBack = false
        return
      }
      let isBack = this.$router.isBack // 监听路由变化时的状态为前进还是后退
      if (isBack) {
        this.$router.toBack = true
      } else {
        this.$router.toBack = false
      }
      this.$router.isBack = false
      window.scroll(0, 0)
    }
  },
  created () {
    // 人人秀登录重定向
    let url = decodeURIComponent((new RegExp('[?|&]' + 'redirectUrl' + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20'))
    if (url) {
      sessionStorage.removeItem('h5_guid')
      sessionStorage.removeItem('otherRedirect')
      location.href = url
    }
  },
  mounted () {
    if (location.href.indexOf('https') < 0 && location.href.indexOf('localhost') < 0) {
      location.href = location.href.replace(/http/, 'https')
    }
    // sessionStorage.setItem('access-token', 'jfd6BtRdfA6IWRW9ue9w5JJkyoWbt7_R')
    this.login()
    if (this.$route.path !== '/') {
      if (!sessionStorage.getItem('projectStart')) {
        sessionStorage.setItem('entranceUrl', encodeURIComponent(window.location.href))
      }
    }
    if (navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1) {
      this.showShare = true
    }
    // 自定义微信分享
    this.setShareConfig()
    this.setVideoId()
    window.onresize = () => {
      this.$root.pageHeight = this.getBrowserInterfaceSize().pageHeight
    }
  },
  methods: {
    isPopconserve () {
      // if (localStorage.getItem('overdueOrderTime1')) {
      //   const oldTime = parseInt(localStorage.getItem('overdueOrderTime1'))
      //   if (this.getAbsTime().getTime() - oldTime < 1000 * 60 * 60 * 24) {
      //     return
      //   }
      // }
      // localStorage.removeItem('overdueOrderTime1')
      this.$axios.get('/order/popconserve').then(res => {
        if (!res.data.ret) {
          if (res.data.datas.content !== null) {
            // localStorage.setItem('overdueOrderTime1', this.getAbsTime().getTime())
            if (this.$route.name !== 'myConserve' && this.$route.name !== 'sendConfirm' && this.$route.name !== 'paySuccess' && this.$route.name !== 'addressManage' && this.$route.name !== 'sendDetail') {
              if (sessionStorage.getItem('webview')) {
                location.href = '/myConserve/10'
              } else {
                this.$router.push('/myConserve/10')
              }
            }
          }
        }
      })
    },
    fukaPopHidden () {
      this.$root.fukaPhoto = ''
      this.$root.fukaPopupVisible = false
    },
    isOverdueOrder () {
      if (localStorage.getItem('overdueOrderTime')) {
        const oldTime = parseInt(localStorage.getItem('overdueOrderTime'))
        if (this.getAbsTime().getTime() - oldTime < 1000 * 60 * 60 * 24) {
          return
        }
      }
      localStorage.removeItem('overdueOrderTime')
      this.$axios.get('/order/conserve', {
        params: {
          type: '1,4',
          page: 1,
          perPage: 5,
          itemState: 10,
          keyword: ''
        }
      }).then(res => {
        if (!res.data.ret) {
          if (res.data.datas.overdueOrder) {
            localStorage.setItem('overdueOrderTime', this.getAbsTime().getTime())
            localStorage.setItem('overdueOrder', 1)
            setTimeout(() => {
              if (sessionStorage.getItem('webview')) {
                location.href = '/myConserve/10'
              } else {
                this.$router.push('/myConserve/10')
              }
              localStorage.removeItem('overdueOrder')
            }, 1000)
          } else {
            localStorage.removeItem('overdueOrder')
          }
        }
      })
    },
    getOverdueOrder () {
      if (localStorage.getItem('overdueOrderTime2')) {
        const oldTime = parseInt(localStorage.getItem('overdueOrderTime2'))
        if (this.getAbsTime().getTime() - oldTime < 1000 * 60 * 60 * 24) {
          return
        }
      }
      localStorage.removeItem('overdueOrderTime2')
      this.$axios.get('/order/overdueorder', {
        params: {
          type: '1,4',
          page: 1,
          perPage: 5,
          itemState: 10,
          keyword: ''
        }
      }).then(res => {
        if (!res.data.ret) {
          if (res.data.datas.isSysgen) {
            localStorage.setItem('overdueOrderTime2', this.getAbsTime().getTime())
            localStorage.setItem('overdueOrder1', 1)
            setTimeout(() => {
              if (sessionStorage.getItem('webview')) {
                location.href = '/myConserve/bill'
              } else {
                this.$router.push('/myConserve/bill')
              }
              localStorage.removeItem('overdueOrder1')
            }, 1000)
          } else {
            localStorage.removeItem('overdueOrder1')
          }
        }
      })
    },
    setShareConfig () {
      this.share.title = '撒米'
      this.share.desc = '拼米拼卷上撒米APP'
      this.share.img = this.baseHome + '/static/logo512.png'
    },
    login () {
      if (location.href.indexOf('webview') > -1) {
        sessionStorage.setItem('webview', 1)
      }
      if (location.href.indexOf('miniUrl') > -1) {
        sessionStorage.setItem('miniUrl', decodeURIComponent((new RegExp('[?|&]' + 'miniUrl' + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null)
      }
      if (location.href.indexOf('loginType') > -1) {
        const fromType = decodeURIComponent((new RegExp('[?|&]' + 'loginType' + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20'))
        this.$sensors.sensorsLogin(fromType, true, 'success')
      }
      let accessToken = decodeURIComponent((new RegExp('[?|&]' + 'access_token' + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
      if (!accessToken && this.$cookies.isKey('access-token')) {
        accessToken = this.$cookies.get('access-token')
      } else if (accessToken) {
        if (sessionStorage.getItem('access-token')) {
          sessionStorage.removeItem('access-token')
        }
        sessionStorage.setItem('access-token', accessToken)
        this.$cookies.set('access-token', accessToken, 3600 * 24 * 3)
        setTimeout(() => {
          this.$historys.pop()
          let url = this.funcUrlDel('access_token').split('.com')[1] || this.funcUrlDel('access_token').split(':8080')[1]
          this.$router.replace(url)
        }, 500)
      }
      if (sessionStorage.getItem('access-token')) {
        this.$getUserInfo().then(datas => {
          this.$sensors.setUser(datas)
          sessionStorage.setItem('headimg', datas.headimg ? this.headimgFun(datas.headimg) : '')
          sessionStorage.setItem('userId', datas.userId || '')
          sessionStorage.setItem('uid', datas.userId || '')
          sessionStorage.setItem('userInviteCode', datas.inviteCode || '')
          sessionStorage.setItem('phone', datas.phone || '')
          sessionStorage.setItem('userType', datas.userType || '')
          // this.$sensors.sensors.login(sessionStorage.getItem('userId'))
          // this.$sensors.sensors.registerPage({
          //   platform_type: 'H5',
          //   is_login: () => {
          //     return !!sessionStorage.getItem('access-token')
          //   },
          //   customer_type: () => {
          //     let customerType = '普通用户'
          //     const userType = sessionStorage.getItem('userType')
          //     if (userType) {
          //       const userTypeSplit = userType.split(',')
          //       switch (userTypeSplit[0]) {
          //         case '30': // 社团
          //           customerType = '社团'
          //           break
          //         case '20': // 达人
          //           customerType = '达人'
          //           break
          //         case '31': // 画手
          //           customerType = '画手'
          //           break
          //         case '70': // 团长
          //           customerType = '团长'
          //           break
          //         default: // 普通用户
          //           customerType = '普通用户'
          //           break
          //       }
          //     }
          //     return customerType
          //   },
          //   channel_source: () => {
          //     return ''
          //   }
          // })
        })
      }
      if (sessionStorage.getItem('access-token') && !sessionStorage.getItem('miniUrl') && !sessionStorage.getItem('webView')) {
      //   localStorage.removeItem('overdueOrder')
      //   localStorage.removeItem('overdueOrder1')
      //   localStorage.removeItem('overdueOrder2')
        this.isPopconserve()
      //   this.isOverdueOrder()
      //   this.getOverdueOrder()
      }
    },
    funcUrlDel (names) {
      if (typeof names === 'string') {
        names = [names]
      }
      let loca = window.location
      let obj = {}
      let arr = loca.search.substr(1).split('&')
      // 获取参数转换为object
      for (let i = 0; i < arr.length; i++) {
        arr[i] = arr[i].split('=')
        obj[arr[i][0]] = arr[i][1]
      }
      // 删除指定参数
      for (let i = 0; i < names.length; i++) {
        delete obj[names[i]]
      }
      // 重新拼接url
      let url = loca.origin + loca.pathname + '?' + JSON.stringify(obj).replace(/[\"\{\}]/g, '').replace(/\:/g, '=').replace(/\,/g, '&')
      return url
    },
    setVideoId () {
      // 获取视频播放的appid
      if (!sessionStorage.getItem('videoAppID')) {
        this.$axios.get('/txcloud-video/getappid').then(res => {
          if (res.data.ret === 0) {
            sessionStorage.setItem('videoAppID', res.data.datas)
          }
        })
      }
    }
  },
  components: {
    wxShare
  }
}
</script>

<style lang="scss">
  @import '../src/styles/global.scss';
  @import '../src/styles/one-point-five-edition.scss';
  @import '../src/styles/new-year.scss';
  @import '../src/styles/new-year-active.scss';
  @import '../src/styles/one-point-eight.scss';
  @import '../src/styles/one-point-nine.scss';
  @import '../src/styles/two-edition.scss';
  .fukaPop {
    background: transparent !important;
    background-color: transparent !important;
    .fukaPop-window {
      width: 560px;
      height: 800px;
      position: relative;
      background: transparent !important;
      background-color: transparent !important;
      img {
        display: block;
        width: 100%;
      }
      .btn-received {
        width: 300px;
        height: 70px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -130px;
        background: transparent url(icons/newYear/wufu/bg-btnReceived.png) 0 0 no-repeat;
        background-size: 100%;
      }
      .btn-close {
        position: absolute;
        top: -80px;
        right: 0;
        transform: translateX(-50%);
        width: 42px;
        height: 80px;
        background: url(icons/newYear/wufu/icon-close.png) 0 no-repeat;
        background-size: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue